import { render, staticRenderFns } from "./Assinaturas.vue?vue&type=template&id=b145b5d2&scoped=true&"
import script from "./Assinaturas.vue?vue&type=script&lang=js&"
export * from "./Assinaturas.vue?vue&type=script&lang=js&"
import style0 from "./Assinaturas.vue?vue&type=style&index=0&id=b145b5d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b145b5d2",
  null
  
)

export default component.exports